export default {
  hotels: [],
  orderedCountries: [],
  filterCountriesList: [],
  filterCitiesList: [],
  filterHotelsList: [],
  filterDestination: {},
  filterOccupancy: {},
  filterDates: {},
  tmsDates: {
    bookingStartDate: null,
    bookingEndDate: null,
    reservationEndDate: null,
    reservationStartDate: null
  },
  promotion: null,
  loadingHotels: false,
  validateIdentity: null,
  filtersCleared: false
}
